export default __webpack_public_path__ + "static/media/buttonUp.3dc39cbf.mp3";